export default __webpack_public_path__ + "static/photo-30363d05246e3f88982ce68ddedebef2.png";